import React, { Fragment, useState } from "react";
// import videoIcon from "../../images/play-square.png";
import Modal from "react-bootstrap/Modal";
import video from "../../images/UserGuide.mp4";
import userManual from "../../Docs/UserManual.pdf";

export const VideoLink = props => {
  const { customClass } = props;
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  return (
    <Fragment>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <video controls width="100%">
            <source src={video} type="video/mp4" />
          </video>
        </Modal.Body>
      </Modal>
      {/* <button
        className={customClass ? customClass + " video-link" : "video-link"}
        onClick={handleShow}>
        <img src={videoIcon} alt="فيديو توضيحي لخدمة تقديم دعوى" />
        فيديو توضيحي لخدمة تقديم الدعوى
      </button> */}
      <a
        href={userManual}
        target="_blank"
        rel="noopener noreferrer"
        className={customClass ? customClass : ""}>
        دليل الخدمات الالكترونية
      </a>
    </Fragment>
  );
};
